import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locals/en.json";

const resources = {
  en: {
    translation: en,
  },
};

void i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    debug: false,
    keySeparator: ".", // we do not use keys in form messages.welcome
    returnObjects: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
export default i18n;
